import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVueComponents from '@/utils/primevue'
import {setApp} from "@/utils/appInstance";
import PrimeVue from 'primevue/config'
import Lara from '@primevue/themes/lara'
import 'primeicons/primeicons.css'
import "leaflet/dist/leaflet.css";
import "./main.css"



const app = createApp(App)

app.use(router)
app.use(PrimeVue, {
    theme: {
        preset: Lara,
        options: {
            prefix: 'p',
            darkModeSelector: '.dark-mode',
        }
    },
    locale: {
        emptyMessage: 'Nenhuma opção disponível',
        firstDayOfWeek: 0,
        dayNames: [
            "domingo", "segunda-feira", "terça-feira", "quarta-feira",
            "quinta-feira", "sexta-feira", "sábado"
        ],
        dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
        dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
        monthNames: [
            "janeiro", "fevereiro", "março", "abril", "maio", "junho",
            "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
        ],
        monthNamesShort: [
            "jan", "fev", "mar", "abr", "mai", "jun",
            "jul", "ago", "set", "out", "nov", "dez"
        ],
        today: "Hoje",
        clear: "Limpar"
    },
})
app.use(PrimeVueComponents);

setApp(app)

app.mount('#app')
